// @file Entrypoint for library accept invite page
import window from '@@/bits/global'
import { setupVueApp } from '@@/bits/vue'
import LibraryAcceptInviteApp from '@@/vuecomponents/LibraryAcceptInviteApp.vue'
import { configure as configureArvo } from '@padlet/arvo'

const { arvoConfig } = window.ww.vueStartingState
void configureArvo(arvoConfig)

void setupVueApp({
  el: '#library_accept_invite_app',
  rootComponent: LibraryAcceptInviteApp,
  usePinia: true,
})
